import icPdf from "../../assets/ic-doc/pdf.svg";
import icImage from "../../assets/ic-doc/image.svg";
import icTxt from "../../assets/ic-doc/text.svg";
import { GoFileZip } from "react-icons/go";
import { MdDownload } from "react-icons/md";
import { imageFromUuid } from "../../helpers/utility";

const DocImg = ({ file, compact = false }) => {
    
    let url = icImage;
    let isZipFile = false;
    const isSigned = String(file?.status || "").toLowerCase() === "signed";

    if( file?.mime_type && file?.mime_type == 'application/pdf'){
        url = icPdf
    }
    else if(['image/png', 'image/jpeg', 'image/gif'].includes(file?.mime_type)){
        url = imageFromUuid(file?.attachment_id);
    }
    else if(file?.mime_type == 'text/plain'){
        url = icTxt
    }
    else if(file?.mime_type == 'application/zip'){
        isZipFile = true;
    }

    return (
        <div className={`flex gap-2 items-center border border-gray-300 rounded-lg relative p-2 min-w-0 ${compact ? 'max-w-full w-full' : ''}`}>
            {isZipFile ? 
                <GoFileZip className="h-10 w-10 shrink-0 text-blue-500" /> 
                : 
                <img src={url} className="h-10 w-10 shrink-0 rounded-lg" alt="" />
            }
            <div className="flex items-center gap-2 min-w-0">
            <span className={`text-sm text-left truncate ${compact ? 'max-w-full' : 'max-w-[300px] md:max-w-none'}`}>{file?.title}</span>
            {isSigned ? (
                <span className="text-[10px] font-semibold uppercase text-green-700 bg-green-100 border border-green-300 rounded px-1.5 py-0.5 shrink-0" title="Document signed">
                    Signed
                </span>
            ) : null}
            {isZipFile && (
                <MdDownload className="text-blue-600 h-5 w-5" />
            )}
            </div>
        </div>
    );
};

export default DocImg;